<template>
  <b-container fluid>
    <b-card
      class="m-4"
      header="Lista de plantões"
      header-text-variant="white"
      header-tag="header"
      header-bg-variant="success"
      footer-tag="footer"
    >
      <b-card-text>
        <b-row>
          <b-col>
            <b-table
              id="tabelaPlantoes"
              :items="myProvider"
              :per-page="perPage"
              :current-page="currentPage"
              :fields="campos_tabela"
              @row-clicked="rowSelected"
              show-empty
              empty-text="Não há plantões cadastrados para você. Procure a Gerência de Ensino e Pesquisa."
              small
            >
              <template v-slot:row-details="row">
                <!-- <p>{{ row }}</p> -->
                <CheckinRefeicao :item="row.item" />
              </template>

              <template v-slot:cell(dia)="data">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <p>
                  {{
                    new Date(data.item.mes).setDate(data.item.dia)
                      | moment("DD/MM/YYYY")
                  }}
                </p>
              </template>

              <template v-slot:cell(acoes)="row">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <b-row align-h="end" class="mr-1">
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="exibeModal(row.item)"
                    v-b-tooltip.hover
                    title="Troca de plantão"
                  >
                    <i class="fa fa-sync-alt" />
                  </b-button>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-modal
      ref="modalTrocaPlantao"
      size="xl"
      id="modal-no-backdrop"
      content-class="shadow"
      centered
      button-size="sm"
      title="Troca de plantão"
      cancelTitle="Cancelar"
      okTitle="Confirmar troca"
      @ok="trocaPlantao"
    >
      <TrocaPlantao
        :plantao="plantao"
        @selecionaProfissional="selecionaProfissional"
      />
    </b-modal>
    <b-alert
      v-model="alertaErro"
      class="position-fixed fixed-bottom m-0 rounded-0"
      style="z-index: 2000;"
      variant="danger"
      dismissible
    >
      <h4>Há erros no formulário</h4>
      <ul>
        <li v-for="(item, index) in mensagensErro" :key="index">{{ item }}</li>
      </ul>
    </b-alert>
  </b-container>
</template>

<script>
import TrocaPlantao from "./TrocaPlantao";
import CheckinRefeicao from "./CheckinRefeicao";
import mixinToast from "@/mixins/mixinToast";

export default {
  mixins: [mixinToast],
  components: {
    TrocaPlantao,
    CheckinRefeicao,
  },
  data() {
    return {
      alertaErro: false,
      mensagensErro: [],
      profissionalSelecionado: null,
      plantao: null,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      campos_tabela: [
        { key: "dia", label: "Dia" },
        { key: "plantao", label: "Plantão" },
        { key: "acoes", label: "Ações", thClass: "cabecalho-direita" },
      ],
      plantoes: [],
    };
  },
  methods: {
    rowSelected(item) {
      if (this.linhaAberta != null) {
        if (this.linhaAberta === item) {
          this.linhaAberta._showDetails = !this.linhaAberta._showDetails;
        } else {
          if (this.linhaAberta._showDetails)
            this.linhaAberta._showDetails = false;
          item._showDetails = !item._showDetails;
          this.linhaAberta = item;
        }
      } else {
        item._showDetails = !item._showDetails;
        this.linhaAberta = item;
      }
    },
    exibeModal(item) {
      this.$refs.modalTrocaPlantao.show();
      this.profissionalSelecionado = null;
      this.plantao = item;
      console.log(item);
    },
    myProvider(ctx) {
      return this.$http
        .get(
          `/escalasporcpf?limit=${ctx.perPage}&page=${ctx.currentPage}&cpf=${this.$store.getters.getLoggedUser.cpf}`
        )
        .then((result) => {
          this.totalRows = result.data.totalRows;
          return result.data.dados.map((item) => {
            item._showDetails = false;
            return item;
          });
        });
    },
    trocaPlantao(event) {
      event.preventDefault();
      if (this.formularioComErro()) {
        return;
      }

      this.$bvModal
        .msgBoxConfirm("Confirma a troca de plantão.", {
          title: "Confirmação",
          okVariant: "success",
          okTitle: "Sim",
          cancelTitle: "Não",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.$http
              .post("/trocaplantao", {
                plantao: this.plantao,
                profissional: this.profissionalSelecionado,
              })
              .then((result) => {
                if (result.data.success) {
                  this.$root.$emit("bv::refresh::table", "tabelaPlantoes");
                }

                this.exibeToast(result.data.success, result.data.message);
                this.$bvModal.hide("modal-no-backdrop");
              });
          }
        });
    },
    selecionaProfissional(profissionalSelecionado) {
      this.profissionalSelecionado = profissionalSelecionado;
    },
    formularioComErro() {
      this.mensagensErro = [];
      var erro = false;

      if (this.profissionalSelecionado == null) {
        this.mensagensErro.push(
          "Escolha um profissional para realizar a troca de plantão."
        );
        erro = true;
      }

      if (erro) this.alertaErro = true;
      return erro;
    },
  },
  mounted() {},
};
</script>

<style></style>]
